export default __webpack_public_path__ + "static/media/j.4115f13f.png";